import { Box, Typography } from '@mui/material';

import {
  useProviderQuestionnaireActions,
  useQuestionnaireClientOptions,
} from './hooks';
import { toQuestionnaireTableRows } from './utils';
import { AddOnboardingQuestionnaireDocuments, QuestionnaireStatusTable } from './components';
import { ProviderQuestionnaireSendSection } from './ProviderQuestionnaireSendSection';
import { QUESTIONNAIRE_SECTION_TITLE_SX } from './styles';

import type { ProviderQuestionnaireProps } from './types';

function ProviderQuestionnaire({ providerId }: ProviderQuestionnaireProps) {
  const { loading, onboardingQuestionnaires, intakeQuestionnaires, sendQuestionnaire } =
    useProviderQuestionnaireActions(providerId);
  const { clientOptions, loading: clientOptionsLoading } =
    useQuestionnaireClientOptions(providerId);
  return (
    <Box sx={{ mt: 3 }}>
      <ProviderQuestionnaireSendSection
        providerId={providerId}
        loading={loading}
        onboardingQuestionnaires={onboardingQuestionnaires}
        intakeQuestionnaires={intakeQuestionnaires}
        clientOptions={clientOptions}
        clientOptionsLoading={clientOptionsLoading}
        sendQuestionnaire={sendQuestionnaire}
      />
      <Box sx={{ mt: 2 }}>
        <Typography sx={QUESTIONNAIRE_SECTION_TITLE_SX}>Questionnaire Log</Typography>
        <QuestionnaireStatusTable
          rows={toQuestionnaireTableRows(onboardingQuestionnaires, intakeQuestionnaires)}
        />
      </Box>
      <AddOnboardingQuestionnaireDocuments onboardingQuestionnaires={onboardingQuestionnaires} />
    </Box>
  );
}

export default ProviderQuestionnaire;
